import { lazy, registerScreen } from "react-native-ridge-navigation";
import { prefetchRecipes } from "@features/recipe/recipes-query";
import { prefetchOrders } from "@features/orderhistory/order-history-query";
import { prefetchOrderDetail } from "@features/orderhistory/order-history-detail-query";

function seo(title: string, description: string) {
  return {
    title: title + " | De Grote Verleiding",
    description,
  };
}
export const HomeScreen = registerScreen(
  "/home",
  lazy(() => import("@features/home/home-screen")),
  () => {},
  seo("Home", "Bij ons kun je winkelen zonder zorgen. Eerlijk, heerlijk en biologisch.")
);

export const SearchScreen = registerScreen(
  "/zoeken",
  lazy(() => import("@features/product/product-screen")),
  () => {},
  seo("Zoeken", "Breed assortiment, eerlijk, heerlijk en biologisch.")
);

export const ProductScreen = registerScreen(
  "/producten/:parentId",
  lazy(() => import("@features/product/product-screen")),
  () => {},
  seo("Boodschappen doen", "Breed assortiment, eerlijk, heerlijk en biologisch.")
);
export const FavouriteRecipesScreen = registerScreen(
  "/mijn-recepten",
  lazy(() => import("@features/recipe/favourite-recipes-screen")),
  () => {},
  seo("Mijn recepten", "Bewaar je favoriete recepten.")
);
export const CartScreen = registerScreen(
  "/mand",
  lazy(() => import("@features/cart/cart-screen")),
  () => {},
  seo("Mand", "Bekijk je mandje en bestel.")
);
export const ProductDetailScreen = registerScreen(
  "/product/:id",
  lazy(() => import("@features/product/product-detail-screen")),
  () => {},
  seo("Product", "Bekijk je product.")
);
export const FavouriteScreen = registerScreen(
  "/lijstjes",
  lazy(() => import("@features/favourite/favourite-screen")),
  () => {},
  seo("Lijstjes", "Bewaar je favoriete producten.")
);

export const FavouriteDetailScreen = registerScreen(
  "/lijstje/:id",
  lazy(() => import("@features/favourite/favourite-detail-screen")),
  () => {},
  seo("Lijstje", "Bekijk je lijstje.")
);
export const RecipeDetailScreen = registerScreen(
  "/recept/:id",
  lazy(() => import("@features/recipe/recipe-detail-screen")),
  () => {},
  seo("Recept", "Bekijk je recept.")
);
export const AccountScreen = registerScreen(
  "/account",
  lazy(() => import("@features/account/account-screen")),
  () => {},
  seo("Account", "Bekijk je account.")
);
export const OrderHistoryScreen = registerScreen(
  "/bestelgeschiedenis",
  lazy(() => import("@features/orderhistory/order-history-screen")),
  () => prefetchOrders(),
  seo("Bestelgeschiedenis", "Bekijk je bestelgeschiedenis.")
);

export const WebshopScreen = registerScreen(
  "/webwinkel/:anchor",
  lazy(() => import("@features/home/webshop/webshop-screen")),
  () => {},
  seo(
    "Werking",
    "Elke week krijg je op vrijdag onze nieuwsbrief met aanbiedingen, nieuwe producten en leuke seizoensgebonden recepten"
  )
);
export const AboutScreen = registerScreen(
  "/over-ons/:anchor",
  lazy(() => import("@features/home/about/about-screen")),
  () => {},
  seo("Over ons", "Bij ons kun je winkelen zonder zorgen. Eerlijk, heerlijk en biologisch.")
);
export const VacanciesScreen = registerScreen(
  "/vacatures",
  lazy(() => import("@features/vacancy/vacancies-screen")),
  () => {},
  seo("Vacatures", "Werken bij De Grote Verleiding? Bekijk onze openstaande vacatures.")
);
export const VacancyDetailScreen = registerScreen(
  "/vacature/:slug",
  lazy(() => import("@features/vacancy/vacancy-detail-screen")),
  () => {},
  seo("Vacature", "Werken bij De Grote Verleiding? Bekijk deze vacature.")
);
export const StampScreen = registerScreen(
  "/stempelkaart",
  lazy(() => import("@features/stamp/stamp-screen")),
  () => {},
  seo("Stempelkaart", "Spaar gratis producten")
);
export const StatiegeldScreen = registerScreen(
  "/statiegeld",
  lazy(() => import("@features/statiegeld/statiegeld-screen")),
  () => {},
  seo("Statiegeld", "Lever je statiegeld in en ontvang geld terug.")
);
export const OrderHistoryDetailScreen = registerScreen(
  "/bestelling/:id/:oid/:round/:invoiceNumber",
  lazy(() => import("@features/orderhistory/order-history-detail-screen")),
  ({ oid, round }) => prefetchOrderDetail({ oid, round }),
  seo("Bestellingen", "Bekijk je bestelgeschiedenis & bestel opnieuw!")
);

export const CreateAccountScreen = registerScreen(
  "/create-account",
  lazy(() => import("@features/auth/create-account-screen")),
  () => {},
  seo("Registreren", "Bij ons kun je winkelen zonder zorgen. Eerlijk, heerlijk en biologisch.")
);
export const LoginScreen = registerScreen(
  "/inloggen",
  lazy(() => import("@features/auth/login-screen")),
  () => {},
  seo("Inloggen", "Bij ons kun je winkelen zonder zorgen. Eerlijk, heerlijk en biologisch.")
);

export const CreateAccountFormScreen = registerScreen(
  "/account-aanmaken/:token",
  lazy(() => import("@features/auth/create-account-form-screen")),
  () => {},
  seo(
    "Registreren",
    "Maak een nieuw account aan bij de Grote Verleiding. Vul je gegevens in en maak een wachtwoord aan."
  )
);
export const PasswordResetConfirmScreen = registerScreen(
  "/wachtwoord-opnieuw-instellen-bevestigen/:token/:email",
  lazy(() => import("@features/auth/password-reset-confirm-screen")),
  () => {},
  seo("Wachtwoord opnieuw instellen", "Vul je nieuwe wachtwoord in om je wachtwoord opnieuw in te stellen.")
);

export const PasswordResetRequestScreen = registerScreen(
  "/wachtwoord-opnieuw-instellen",
  lazy(() => import("@features/auth/password-reset-request-screen")),
  () => {},
  seo("Wachtwoord opnieuw instellen", "Vul je nieuwe wachtwoord in om je wachtwoord opnieuw in te stellen.")
);
export const CategoryScreen = registerScreen(
  "/boodschappen-doen",
  lazy(() => import("@features/product/category-screen")),
  () => {},
  seo("Boodschappen doen", "Heerlijk, eerlijk en biologisch boodschappen doen!")
);
export const RecipesScreen = registerScreen(
  "/recepten",
  lazy(() => import("@features/recipe/recipes-screen")),
  () => prefetchRecipes(),
  seo("Recepten", "Heerlijk biologische recepten die je gelijk kunt bestellen!")
);
export const MarketScreen = registerScreen(
  "/boerenmarkt",
  lazy(() => import("@features/home/market-screen")),
  () => {},
  seo(
    "Boerenmarkt",
    "Iedere zaterdagochtend van 08.30 - 11.00 uur kun je op de Biologische Boerenmarkt aardappelen, groente, fruit en eieren kopen."
  )
);

export const ContactScreen = registerScreen(
  "/contact",
  lazy(() => import("@features/contact/contact-screen")),
  () => {},
  seo(
    "Contact",
    "Heb je een vraag over een product, wil je klant worden of kunnen we je op een andere manier helpen? Neem dan contact met ons op."
  )
);
export const LoginOrSignupScreen = registerScreen(
  "/inloggen-of-aanmelden",
  lazy(() => import("@features/auth/login-or-signup-screen")),
  () => {},
  seo("Inloggen of aanmelden", "Bij ons kun je winkelen zonder zorgen. Eerlijk, heerlijk en biologisch.")
);
export const AccountDeleteScreen = registerScreen(
  "/account-verwijderen",
  lazy(() => import("@features/account/account-delete-screen")),
  () => {}
);
export const PrivacyScreen = registerScreen(
  "/privacy-verklaring",
  lazy(() => import("@features/privacy/privacy-screen")),
  () => {},
  seo("Privacy verklaring", "Als je iets bestelt, hebben we je persoonlijke gegevens nodig om ervoor te zorgen dat we jouw bestelling kunnen bezorgen.")
);
// Fotobeheer: alleen zichtbaar en bruikbaar voor accounts op de allowlist van
// de server (zie features/beheer). Geen seo: hoort niet in zoekmachines.
export const BeheerScreen = registerScreen(
  "/beheer",
  lazy(() => import("@features/beheer/beheer-screen")),
  () => {}
);
export const BeheerActivityScreen = registerScreen(
  "/beheer/activiteit",
  lazy(() => import("@features/beheer/beheer-activity-screen")),
  () => {}
);
export const BeheerDetailScreen = registerScreen(
  "/beheer/:kind/:key",
  lazy(() => import("@features/beheer/beheer-detail-screen")),
  () => {}
);
export const TermsScreen = registerScreen(
  "/algemene-voorwaarden",
  lazy(() => import("@features/account/terms-screen")),
  () => {},
  seo("Algemene Voorwaarden", "Lees onze algemene voorwaarden voor het gebruik van onze webshop en diensten.")
);
